import { Outlet } from 'react-router';
import { useBreadcrumb } from '~/components/layout/Breadcrumb';

export default function VftManagerBreadcrumbWrapperRoute() {
  useBreadcrumb('routes/upload/vft-manager', 'VFT Manager');
  return <Outlet />;
}
